import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useRequiredFields from "../../../../hooks/useRequiredFields";
import FormValidation from "../../../Common/FormValidation";
import Http from "../../../Common/Http";
import { LoaderComponent } from "../../../Common/LoaderComponent";
import { ProgressSpinner } from "primereact/progressspinner";

const Edit = (props) => {
  const navigate = useNavigate();
  const [inputs, setInputs] = useState({});
  const { id } = useParams();
  const [staff, setStaff] = useState([]);
  const [error, setError] = useState({});
  const { checkRequiredFields } = useRequiredFields();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      try {
        const transactionRes = await Http.get("/transaction/" + id + "/edit");

        // Set all the fields from the API response
        setInputs({
          hr_staff_basic_info_id: transactionRes.data.hr_staff_basic_info_id,
          total_amount: transactionRes.data.total_amount,
          date: transactionRes.data.date,
          rate: transactionRes.data.rate || "",
          total_hours: transactionRes.data.total_hours || "",
          remarks: transactionRes.data.remarks || "",
          is_tuesday: transactionRes.data.is_tuesday || 0,
        });

        const staffRes = await Http.get("/staff");
        setStaff(staffRes.data);
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };

  // Handle rate change and calculate total amount
  const handleRateChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((prevInputs) => {
      const updatedInputs = { ...prevInputs, [name]: value };

      // Calculate total amount if both rate and total_hours are available
      if (value && prevInputs.total_hours) {
        updatedInputs.total_amount = (
          parseFloat(value) * parseFloat(prevInputs.total_hours)
        ).toFixed(2);
      }

      return updatedInputs;
    });
  };

  // Handle hours change and calculate total amount
  const handleHoursChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputs((prevInputs) => {
      const updatedInputs = { ...prevInputs, [name]: value };

      // Calculate total amount if both rate and total_hours are available
      if (value && prevInputs.rate) {
        updatedInputs.total_amount = (
          parseFloat(prevInputs.rate) * parseFloat(value)
        ).toFixed(2);
      }

      return updatedInputs;
    });
  };

  const formSubmit = () => {
    if (checkRequiredFields()) {
      const submitData = {
        ...inputs,
        type: "overtime",
      };

      Http.put("/transaction/" + id, submitData)
        .then((res) => {
          navigate("/overtime", {
            state: { message: res.data.message, type: res.data.type },
          });
        })
        .catch(function (e) {
          if (e.response && e.response.data && e.response.data.errors) {
            setError(e.response.data.errors);
          } else {
            console.error("Update error:", e);
          }
        });
    }
  };

  return (
    <div>
      {/* <LoaderComponent /> */}
      <div className="am-mainpanel">
        <div className="am-pagetitle">
          <h5 className="am-title">Edit Overtime Salary Form</h5>
        </div>
        <div className="am-pagebody">
          <div className="card pd-20 pd-sm-40">
            <h6 className="card-body-title mg-sm-b-30">
              Edit Overtime Salary Form
            </h6>
            <div className="row">
              <div className="col-lg">
                <FormValidation error={error} />
              </div>
            </div>
            {loading ? (
              <ProgressSpinner />
            ) : (
              <>
                <div className="row">
                  <div className="col-lg">
                    <label htmlFor="">
                      Staff <i className="fa fa-star required"></i>
                    </label>
                    <select
                      className="form-control"
                      name="hr_staff_basic_info_id"
                      value={inputs.hr_staff_basic_info_id || ""}
                      onChange={handleChange}
                      data-required
                    >
                      <option value="">Select Staff</option>
                      {Array.from(staff).map((item, index) => (
                        <option value={item.id} key={item.id}>
                          {item.card_no + " - " + item.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-lg">
                    <label>
                      Date <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="date"
                      className="form-control"
                      name="date"
                      value={inputs.date || ""}
                      onChange={handleChange}
                      data-required
                    />
                  </div>
                  <div className="col-lg">
                    <label>
                      Rate <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control"
                      name="rate"
                      value={inputs.rate || ""}
                      onChange={handleRateChange}
                      placeholder="Enter hourly rate"
                      data-required
                    />
                  </div>
                  <div className="col-lg">
                    <label>
                      Total Hours <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      className="form-control"
                      name="total_hours"
                      value={inputs.total_hours || ""}
                      onChange={handleHoursChange}
                      placeholder="Enter total hours"
                      data-required
                    />
                  </div>
                  <div className="col-lg">
                    <label>
                      Total Amount <i className="fa fa-star required"></i>
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      readOnly
                      className="form-control bg-light"
                      name="total_amount"
                      value={inputs.total_amount || ""}
                      data-required
                    />
                  </div>
                </div>

                <div className="row mt-3">
                  {/* <div className="col-lg-6">
                    <label>Is Tuesday Overtime?</label>
                    <select
                      className="form-control"
                      name="is_tuesday"
                      value={inputs.is_tuesday || 0}
                      onChange={handleChange}
                    >
                      <option value={0}>No</option>
                      <option value={1}>Yes</option>
                    </select>
                  </div> */}
                  <div className="col-lg-6">
                    <label>Remarks</label>
                    <textarea
                      className="form-control"
                      name="remarks"
                      value={inputs.remarks || ""}
                      onChange={handleChange}
                      placeholder="Enter remarks (optional)"
                      rows="3"
                    />
                  </div>
                </div>

                <div className="row mt-4">
                  <div className="col-lg-3">
                    <button
                      className="btn btn-primary btn-block mg-b-10"
                      onClick={formSubmit}
                      disabled={loading}
                    >
                      <i className="fa fa-send mg-r-10"></i>
                      {loading ? "Updating..." : "Update"}
                    </button>
                  </div>
                  <div className="col-lg-3">
                    <button
                      className="btn btn-secondary btn-block mg-b-10"
                      onClick={() => navigate("/overtime-tuesday")}
                      type="button"
                    >
                      <i className="fa fa-arrow-left mg-r-10"></i> Cancel
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
          {/* card */}
        </div>
      </div>
    </div>
  );
};

export default Edit;
